import { render } from "./addComponent.vue?vue&type=template&id=8f8febce&scoped=true"
import script from "./addComponent.vue?vue&type=script&lang=js"
export * from "./addComponent.vue?vue&type=script&lang=js"

import "./addComponent.vue?vue&type=style&index=0&id=8f8febce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8febce"]])

export default __exports__